import { useState } from "react";
import { toast } from "react-toastify";
import { useAuth } from "../context/AuthContext";
import { handleErrors } from "../services/handleErrors";

const useMutter = (serviceMutter) => {
  const { refreshToken } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);

  const callService = async (params, options = {}) => {
    setIsLoading(true);
    try {
      // eslint-disable-next-line prefer-spread
      const result = await serviceMutter.apply(null, Array.isArray(params) ? params : [params]);
      setError(false);
      setIsLoading(false);
      return [result.result, null];
    } catch (err) {
      handleErrors(err, toast.error, refreshToken, options.formik);
      setError(err);
      setIsLoading(false);
      return [null, err];
    }
  };

  return [callService, isLoading, error];
};

export default useMutter;
